import { render, staticRenderFns } from "./PersonnelRecordEditTabPhysicals.vue?vue&type=template&id=079cbf04"
import script from "./PersonnelRecordEditTabPhysicals.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordEditTabPhysicals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports